import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DateModel } from '../../../../../../shared/models/date.model';
import { DateService } from '../../../../../../shared/service/date.service';
import Swal from 'sweetalert2';
import { DateTimepickerComponent } from '../../../../../../shared/components/date-timepicker/date-timepicker.component';

@Component({
  selector: 'app-datetime-range-picker',
  templateUrl: './datetime-range-picker.component.html',
  styleUrls: ['./datetime-range-picker.component.scss']
})
export class DatetimeRangePickerComponent implements OnInit {
  @ViewChild('FromDateTime', { static: true }) fromDateTime!: DateTimepickerComponent;
  @ViewChild('ToDateTime', { static: true }) toDateTime!: DateTimepickerComponent;
  @Input() required: boolean = true;
  @Input() type!: string;

  private Toast = Swal.mixin({
    toast: true,
    position: 'top',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  });

  @Output() selectedRangeDate = new EventEmitter<string | null>();
  selectedDateRange!: '1h' | '3h' | 'Today' | 'AWeekAgo' | 'ThreeDaysAgo' | 'Yesterday' | 'LastMonth' | 'ThisMonth' | 'All';
  fromDate?: Date;
  toDate ?: Date;
  currentMonthName = this.dateService.getMonthJalaliName();
  previousMonthName = this.dateService.getMonthJalaliName(1);

  constructor(private dateService: DateService) {
  }


  ngOnInit(): void {
    if (this.required) {
      this.setDateRange('Today');
    } else {
      this.setDateRange('All');
    }
  }

  setDateRange(range: '1h' | '3h' | 'Today' | 'Yesterday' | 'LastMonth' | 'ThisMonth' | 'All' | 'AWeekAgo' | 'ThreeDaysAgo') {
    this.selectedDateRange = range;
    if (range !== 'All') {
      const dateTimeRange = this.dateService.getDateTimeFrame(range);
      this.fromDate = this.dateService.convertDateModelToDateWithTimezone(dateTimeRange[0]);
      this.fromDateTime.setDateAndTime(dateTimeRange[0]);
      this.toDate = this.dateService.convertDateModelToDateWithTimezone(dateTimeRange[1]);
      this.toDateTime.setDateAndTime(dateTimeRange[1]);
      this.selectedRangeDate.emit(`${this.dateService.convertDateToSqlDateUTC(this.fromDate)},${this.dateService.convertDateToSqlDateUTC(this.toDate)}`);
    } else {

      this.selectedRangeDate.emit(null);
    }

  }

  getDate(date: DateModel, type: 'from' | 'to') {
    switch (type) {
      case 'from':
        this.fromDate = this.dateService.convertDateModelToDateWithTimezone(date);
        break;
      case 'to':
        this.toDate = this.dateService.convertDateModelToDateWithTimezone(date);
    }
    if (this.fromDate && this.toDate && this.toDate.getTime() <= this.fromDate.getTime()) {
      this.Toast.fire({ icon: 'error', text: 'تاریخ انتهای بازه نباید از تاریخ ابتدا کوچیک‌تر یا مساوی باشد.' });
      this.setDateRange(this.selectedDateRange);
      this.toDateTime.resetSelectedDate();
    } else if (this.fromDate && this.toDate) {
      this.selectedRangeDate.emit(`${this.dateService.convertDateToSqlDateUTC(this.fromDate)},${this.dateService.convertDateToSqlDateUTC(this.toDate)}`);
    }
  }

  updateRangeChange(selected: any[]) {
    this.selectedDateRange = selected[0] as '1h' | '3h' | 'Today' | 'Yesterday' | 'LastMonth' | 'ThisMonth' | 'All';

  }
}
